<app-base-page-template>
  <app-base-page-content-template>
    <app-businesses-grid
      (addButtonClick)="onAddButtonClicked()"
      (rowClick)="onRowClicked($event)">
    </app-businesses-grid>
  </app-base-page-content-template>
</app-base-page-template>
